import React from "react";
import "../css/privacy.scss";

function Privacy() {
  return (
    <div className="privacy">
      <div className="policy-container">
        <h1>Privacy Policy</h1>

        <h2>Your privacy is very important to us.</h2>
        <p>
          To ensure all customers understand the lengths we go to protect
          privacy, we provide a notice on each receipt on every transaction.
        </p>

        <h2>What Info Do We Collect?</h2>
        <p>
          This applies to all information collected or submitted on this
          website. On some pages, you can order products or register to receive
          information from us. The types of personal information collected at
          these pages are:
        </p>
        <ul>
          <li>Name</li>
          <li>Address</li>
          <li>Email address</li>
        </ul>

        <p>
          On some pages, you can submit information about other people. For
          example, if you order a gift online and want it sent directly to the
          recipient, you will need to submit the recipient's address. In this
          circumstance, the types of personal information collected are:
        </p>
        <ul>
          <li>Name</li>
          <li>Address</li>
        </ul>

        <h2>The Information We Do Not Collect:</h2>
        <p>
          Credit/Debit Card Information - we use a third party payment processor
          to handle this information securely. None of your Credit/Debit card
          information is stored anywhere on this site.
        </p>
        <h2>How We Use Information</h2>
        <p>We use personal information to process orders, provide customer support, prevent fraud, meet legal obligations and improve our services.</p>
        <h2>Retention and Your Rights</h2>
        <p>We keep information only as long as necessary for the purposes described above. You may request access, correction or deletion by emailing send@isanroute.space, subject to applicable law.</p>
        <h2>Cookies</h2>
        <p>Our cart uses essential browser storage. Please read our Cookie Policy for more information about controls and optional technologies.</p>
        <h2>Service Providers</h2>
        <p>We share only the information needed with payment, hosting, fraud-prevention and delivery providers that help us complete your order.</p>
        <h2>Security</h2>
        <p>We use reasonable administrative and technical safeguards. No internet transmission is completely secure, so please avoid sending sensitive payment details by email.</p>
        <h2>Policy Updates</h2>
        <p>We may update this notice when our services or legal obligations change. The current version will remain available on this page.</p>
      </div>
    </div>
  );
}

export default Privacy;
